import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'stack-2', 'Stack2', [["path",{"d":"M12 4l-8 4l8 4l8 -4l-8 -4"}],["path",{"d":"M4 12l8 4l8 -4"}],["path",{"d":"M4 16l8 4l8 -4"}]]);